<template>
  <div>
    <div class="dropdown-content select-actions"
         ref="dropdownContent">
      <div v-if="modalState === 'gif'"
           class="select-campaign-attachment select-gif-attachment">
        <div class="attachment-select-header">
          <span><i class="icon-feather-grid"></i> Choose a GIF</span>
          <div class="giphy-c"></div>
        </div>
        <form action="?" @submit.prevent="$refs.gifSearch.blur()">
          <div class="input-with-icon">
            <input autocomplete="off"
                   type="text"
                   class="input-sm"
                   name="gifSearch"
                   placeholder="Search GIPHY"
                   ref="gifSearch"
                   v-model="gifSearch"
            ><i style="pointer-events: auto"
                v-on:click="$refs.gifSearch.blur()" class="icon-material-outline-search"></i>
          </div>
        </form>
        <div class="gif-list-wrap">
          <div class="gif-list">
            <div v-for="gif in gifImages"
                 :key="gif.id"
                 class="one-gif">
              <a href="#"
                 v-on:click.prevent="closeAllDropdowns();$emit('select-attachment', {type: 'add-photo', link: clearParams(gif.images.original.url)})"
              ><img v-lazy="gif.images.fixed_width_downsampled.url"
                    width="140"
                    :height="gif.images.fixed_width_downsampled.height * .7"
                    alt="">
              </a>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="dropdown-header">Add to your Message <span>Choose 1 of the following:</span></div>
        <ul class="dropdown-body">
          <li v-if="charityInfo && !linksOnly">
            <a href="#"
               v-on:click.prevent="$emit('select-attachment', {type: 'ask-for-donation', link: `${config.scheme}://${charityInfo.subdomain}.${config.url}/wv2/donate`})"
               class="item item-heart attach-ask-for-donation">
              <div class="title">Ask for a Donation
                <p class="sub-title">Send a donation link with your message</p>
              </div>
            </a>
          </li>
          <li v-if="linksOnly">
            <div class="item item-send-link">

              <div class="title"><label for="select-donation-page">Ask for a Donation</label>
                <p class="sub-title">Send a donation link with your message</p>

                <select v-model="askDonationPage"
                        class="event-page select-event-page"
                        id="select-donation-page"
                        v-if="charityInfo"
                >
                  <option value="">Choose a Donation Type</option>
                  <option :value="`${config.scheme}://${charityInfo.subdomain}.${config.url}/wv2/donation/one-time`">
                    One-Time
                  </option>
                  <option :value="`${config.scheme}://${charityInfo.subdomain}.${config.url}/wv2/donation/monthly`">
                    Monthly
                  </option>
                  <option :value="`${config.scheme}://${charityInfo.subdomain}.${config.url}/wv2/donation/round-ups`">
                    Round-Ups
                  </option>
                </select>
              </div>
            </div>
          </li>
          <li>
            <a href="#"
               v-on:click.prevent="isAttachPostModal = true"
               class="item item-bookmark show-modal-attach-post">
              <div class="title">Attach an Impact Post
                <p class="sub-title">Send a specific Impact Post with your message</p>
              </div>
            </a>
          </li>
          <li v-if="!linksOnly"
              name="upload-not-allowed1"
              :class="{'not-allowed': !$root.checkFeature('messages_attachments')}">
            <a v-on:click.prevent="openCanva"
               href="#"
               class="item item-canva">
              <div class="title">Design in Canva
                <p class="sub-title">Create a graphic using Canva</p>
              </div>
            </a>
          </li>

          <li v-if="!linksOnly"
              name="upload-not-allowed2"
              :class="{'not-allowed': !$root.checkFeature('messages_attachments')}">
            <div class="item item-picture">
              <div class="title">Add a Photo
                <p class="sub-title">Send a photo with your message</p>
              </div>
              <input type="file" accept="image/*"
                     @change="onImageChanged"
                     class="add-photo-upload">
            </div>
          </li>
          <li v-if="!linksOnly"
              name="upload-not-allowed3"
              :class="{'not-allowed': !$root.checkFeature('messages_attachments')}">
            <a href="#" v-on:click.prevent="isAddVideoModal = true" class="item item-video">
              <div class="title">Add a Video
                <p class="sub-title">Choose a video file or post a YouTube Link</p>
              </div>
            </a>
          </li>
          <li v-if="!linksOnly"
              name="upload-not-allowed4"
              :class="{'not-allowed': !$root.checkFeature('messages_attachments')}">
            <a href="#"
               v-on:click.prevent.stop="setModalState('gif')"
               class="item item-gif"
            >
              <div class="title">Choose a GIF
                <p class="sub-title">Pick out a GIF to send to your supporters</p>
              </div>
            </a>
          </li>

          <li v-if="charityInfo && campaigns.length" class="send-link-wrap">
            <div class="item item-send-link">

              <div class="title"><label for="select-event-page">Link to a Campaign</label>
                <p class="sub-title">Send users to a specific campaign</p>

                <select @change="onSelectPage"
                        v-model="eventPage"
                        class="event-page select-event-page"
                        name="event-page"
                        id="select-event-page">
                  <option value="">Choose a Campaign</option>
                  <option v-for="(campaign, index) in campaigns"
                          :key="index"
                          :value="campaignLink(campaign)"
                  >{{campaign.name}}
                  </option>
                </select>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <tippy v-if="!$root.checkFeature('download_report')" to="upload-not-allowed1" arrow >
        <div>Upgrade to Design in Canva</div>
      </tippy>
      <tippy v-if="!$root.checkFeature('download_report')" to="upload-not-allowed2" arrow >
        <div>Upgrade to add a Photo</div>
      </tippy>
      <tippy v-if="!$root.checkFeature('download_report')" to="upload-not-allowed3" arrow >
        <div>Upgrade to add a Video</div>
      </tippy>
      <tippy v-if="!$root.checkFeature('download_report')" to="upload-not-allowed4" arrow >
        <div>Upgrade to add a Gif</div>
      </tippy>

    </div>

    <modal v-if="isAttachPostModal"
           v-on:close-modal="isAttachPostModal = false"
           v-on:select-post="selectPost"
           :modal-name="'msg-attach-post'"></modal>

    <modal v-if="isAddVideoModal"
           v-on:close-modal="isAddVideoModal = false"
           v-on:select-video="selectVideo"
           :modal-name="'msg-add-video'"></modal>
  </div>
</template>

<script>
  import {getAllCampaigns, globalImageUploader} from '../../utils/api';
  import Modal from '../Modal/index.vue';
  import config from '../../../public/harness_config.json';
  import attachmentGifMixin from './attachment-gif-mixin';
import { getImageFromURL } from '../../utils/utils';

  export default {
    name: 'AddAttachment',
    mixins: [attachmentGifMixin],
    components: {
      Modal,
    },
    props: {
      charityInfo: null,
      imageError: null,
      imageIsLoading: null,
      imageLoadingPercent: null,
      linksOnly: {
        type: Boolean,
        default: false,
      },
    },
    mounted() {
      getAllCampaigns().then(campaigns => {
        this.campaigns = campaigns;
      });
    },
    methods: {
      openCanva() {
        this.$root.canva.createDesign({
          type: 'SocialMedia',
          fileType: 'jpg',
          onDesignPublish: this.onCanvaCallback,
        });
      },
      onCanvaCallback(options) {
        this.$emit('update:imageLoadingPercent', 0);
        this.$emit('update:imageIsLoading', true);
        const loadingCallBack = (progressEvt) => {
          this.$emit('update:imageLoadingPercent', parseInt(progressEvt.loaded / progressEvt.total * 100));
        };

        getImageFromURL(options.exportUrl).then((image) => {
          globalImageUploader(image, loadingCallBack).then((result) => {
            this.$emit('update:imageIsLoading', false);
            if (result) {
              this.$emit('select-attachment', {type: 'add-photo', link: result});
            } else {
              this.$emit('update:imageError', 'Image uploading error');
            }
          }).catch(() => {
            this.$emit('update:imageIsLoading', false);
            this.$emit('update:imageError', 'Image uploading error');
          });
        });
      },
      campaignLink(campaign) {
        if (this.charityInfo && campaign) {
          return `${config.donor_next_scheme}://${this.charityInfo.subdomain}.${config.donor_next_url}/campaigns/${campaign.id}`;
        }
        return '';
      },
      selectVideo(video) {
        this.isAddVideoModal = false;
        this.$emit('select-attachment', {
          type: 'add-video',
          link: video.link,
        });
      },
      onImageChanged(e) {
        const file = e.target.files[0];
        const self = this;

        if (file) {
          if (file.size / 1024 / 1024 > 5) {
            this.$emit('update:imageError',
              'Unfortunately, your image file is too large. Please choose an image under 5MB - Thanks');

            return false;
          } else {
            this.$emit('update:imageError', '');
          }
          this.$emit('update:imageLoadingPercent', 0);
          this.$emit('update:imageIsLoading', true);
          const loadingCallBack = function(progressEvt) {
            self.$emit('update:imageLoadingPercent', parseInt(progressEvt.loaded / progressEvt.total * 100));
          };

          globalImageUploader(file, loadingCallBack).then((result) => {
            this.$emit('update:imageIsLoading', false);
            if (result) {
              this.$emit('select-attachment', {type: 'add-photo', link: result});
            } else {
              this.$emit('update:imageError', 'Image uploading error');
            }
          }).catch(() => {
            this.$emit('update:imageIsLoading', false);
            this.$emit('update:imageError', 'Image uploading error');
          });
        }
      },
      selectPost(post) {
        this.$emit('select-attachment', {
          type: 'attach-post',
          link: `${config.donor_next_scheme}://${this.charityInfo.subdomain}.${config.donor_next_url}/posts/${post.feedback_id}`,
        });
        this.isAttachPostModal = false;
      },
      onSelectPage() {
        if (this.eventPage) {
          [...document.querySelectorAll('.dropdown-content')].map((item) => {
            item.classList.remove('show');
          });
          this.$emit('select-attachment', {type: 'campaign', link: this.eventPage});
          this.eventPage = '';
        }
      },
    },
    computed: {
      config() {
        return config;
      },
    },
    watch: {
      'askDonationPage'() {
        if (this.askDonationPage) {
          [...document.querySelectorAll('.dropdown-content')].map((item) => {
            item.classList.remove('show');
          });
          this.$emit('select-attachment', {type: 'ask-for-donation', link: this.askDonationPage});
          this.$nextTick(() => this.askDonationPage = '');
        }
      },
    },
    data() {
      return {
        eventPage: '',
        askDonationPage: '',
        isAttachPostModal: false,
        isAddVideoModal: false,
        campaigns: [],
      };
    },
  };
</script>

<style lang="scss" scoped>
  .dropdown-body{
    padding-bottom: 12px !important;
    .item{
      margin-top: 13px !important;
    }
  }
</style>

<style lang="scss">
  .select-campaign-attachment {

    &.select-gif-attachment {
      width: 460px;
      height: auto;
      @media (max-width: 550px) {
        width: 310px;
      }

      .gif-list-wrap {
        height: 200px;
        overflow-y: auto;
        padding: 0 5px;
        -ms-overflow-style: none; // IE 10+
        scrollbar-width: none; // Firefox
        &::-webkit-scrollbar {
          display: none; // Safari and Chrome
        }
      }

      .gif-list {
        width: 450px;
        margin-top: -5px;
        column-width: 150px;
        column-gap: 0;
        @media (max-width: 550px) {
          width: 300px;
        }

        .one-gif {
          padding: 5px;
          width: 150px;
          display: inline-block;
          column-break-inside: avoid;
        }

        .one-gif a {
          padding: 0;
        }
        .one-gif img {
          width: 100%;
        }
      }
    }

    width: 500px;
    height: 242px;
    max-width: 90vw;


    .attachment-select-header {
      color: #677788;
      margin: 5px 10px;

      position: relative;
      padding: 10.5px 20px 10.5px 35px;
      min-height: 30px;
      background-image: url("../../assets/icons/add-gif.svg");
      background-size: 30px;
      background-position: left center;
      background-repeat: no-repeat;
      .giphy-c{
        background-image: url("../../assets/icons/giphy.png");
        width: 200px;
        height: 42px;
        position: absolute;
        right: 0;
        top: -5px;
      }
    }

    .input-with-icon {
      padding: 0 10px;
      position: relative;
    }

    .input-with-icon :after{
      content: '';
      display: block;
      position: absolute;
      right: 10px;
      width: 36px;
      height: 36px;
      background: url("../../assets/icons/search-icon.svg") center no-repeat;
      background-size: 16px;
      top: 3px;

    }

    .input-with-icon input[type=text] {
      border: 1px solid #eaeaea;
      margin-bottom: 10px;
      width: 100%;
    }
  }

  .select-gif-attachment .input-with-icon input[type="text"] {
    height: 40px;
    line-height: 40px;
    box-shadow: none;
  }

</style>
